module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (!_vm.inline) ? _c('div', {
    staticClass: "radio",
    class: [_vm.setDis]
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "aria-label": "..."
    },
    domProps: {
      "value": _vm.val
    }
  }), _vm._v("\n    \t\t" + _vm._s(_vm.label) + "\n  \t\t")])]) : _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.val
    }
  }), _vm._v("\n\t\t" + _vm._s(_vm.label) + "\n  \t")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-517763ce!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/radio.vue
// module id = 313
// module chunks = 2